export const parseSchedule = (hWork, zWork) => {
  if (!hWork) {
    return {
      weekdays: { start: '-', lunch: '-', end: '-' },
      saturday: 'вихідний',
      sunday: 'вихідний'
    };
  }

  const hParts = hWork.split('.:');
  const zParts = zWork ? zWork.split('.:') : [];

  const weekdayTime = hParts[1] ? hParts[1].replace(/\s*Сб.*$/, '').trim() : '';
  const weekdayZ = zParts[1] ? zParts[1].replace(/\s*Сб.*$/, '').trim() : '';

  const saturdayTime = hParts[2] ? hParts[2].replace(/\s*Нд.*$/, '').trim() : '';
  const saturdayZ = zParts[2] ? zParts[2].replace(/\s*Нд.*$/, '').trim() : '';

  const sundayTime = hParts[3] ? hParts[3].trim() : '';
  const sundayZ = zParts[3] ? zParts[3].trim() : '';

  const isSaturdayClosed = !saturdayTime || saturdayTime === '-' ||
                           saturdayTime.toLowerCase().includes('вихідний') ||
                           saturdayTime === '--' || saturdayTime === '---';

  const isSundayClosed = !sundayTime || sundayTime === '-' || sundayTime === '--' ||
                         sundayTime === '---' || sundayTime.toLowerCase().includes('вихідний');

  return {
    weekdays: {
      start: weekdayTime.split('-')[0] || '-',
      lunch: weekdayZ.split('-')[1] || '-',
      end: weekdayTime.split('-')[1] || '-',
    },
    saturday: isSaturdayClosed ? 'вихідний' : {
      start: saturdayTime.split('-')[0] || '-',
      lunch: saturdayZ.split('-')[1] || '-',
      end: saturdayTime.split('-')[1] || '-',
    },
    sunday: isSundayClosed ? 'вихідний' : {
      start: sundayTime.split('-')[0] || '-',
      lunch: sundayZ.split('-')[1] || '-',
      end: sundayTime.split('-')[1] || '-',
    }
  };
};

export const parseServices = (opt) => {
  if (!opt) return [];
  if (Array.isArray(opt)) return opt;
  if (typeof opt !== 'string') return [];
  return opt.replace(/{|}/g, '').split(',').map(s => s.trim()).filter(Boolean);
};

export const extractLoad = (opt) => {
  if (!opt) return 60;

  const optStr = Array.isArray(opt) ? opt.join(',') : String(opt);
  const loadMatch = optStr.match(/load(\d+)/);
  if (loadMatch && loadMatch[1]) {
    return parseInt(loadMatch[1], 10);
  }

  return 60;
};

export const formatAddress = (address) => {
  if (!address) return '';
  const withoutCity = address.replace(/^(м\.|смт|с\.)\s*[^,]+,\s*/, '');
  return withoutCity.trim();
};
